/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApproveWorkLogDto } from '../../models/approve-work-log-dto';
import { WorkLog } from '../../models/work-log';

export interface WorkLogsControllerApprove$Params {
  id: string;
      body: ApproveWorkLogDto
}

export function workLogsControllerApprove(http: HttpClient, rootUrl: string, params: WorkLogsControllerApprove$Params, context?: HttpContext): Observable<StrictHttpResponse<WorkLog>> {
  const rb = new RequestBuilder(rootUrl, workLogsControllerApprove.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<WorkLog>;
    })
  );
}

workLogsControllerApprove.PATH = '/work-logs/{id}/approve';
